import { createStore } from 'satcheljs';
import { ObservableMap } from 'mobx';
import { MailboxInfo } from 'owa-client-ids';

const getStore = createStore<ObservableMap<string, MailboxInfo>>(
    'mailboxInfoStore',
    new ObservableMap()
);

export default getStore;
